import { useAuth } from '../../context/useAuth'
import { useWorkspace } from '../../context/useWorkspace'
import { requestWorkspaceSwitch } from '../../services/workspaceSwitchService'
import { useNls } from '../../nls/nlsProvider'
import { Login } from '../Auth/Login'
import { JoinWithCodeForm, type ClaimedJoinCodeInfo } from './JoinWithCodeForm'

export const JoinWithCodePage = () => {
  const { currentUser } = useAuth()
  const { refreshWorkspaces } = useWorkspace()
  const { t } = useNls()

  if (!currentUser) {
    // Like InviteReviewPage.tsx:129, render Login in place so ?code= is preserved in the URL through sign-in
    return <Login />
  }

  const queryCode = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('code') || ''
    : ''

  const handleClaimed = async (claimed: ClaimedJoinCodeInfo) => {
    // Standard workspace-switch path: hydrate memberships via refreshWorkspaces,
    // switch active workspace id, then redirect to root dropping ?code=
    await refreshWorkspaces(claimed.workspaceId)
    await requestWorkspaceSwitch({
      toWorkspaceId: claimed.workspaceId,
      source: 'JOINED',
      landing: '/',
    })
  }

  return (
    <main className="flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-md rounded-xl border border-[var(--border)] bg-[var(--surface-raised)] p-6 shadow-lg">
        <h1 className="mb-2 text-xl font-bold text-[var(--text-strong)]">{t('NLSJoinWithCodeDialogTitle')}</h1>
        <p className="mb-6 text-sm text-[var(--muted)]">{t('NLSJoinWithCodeDialogDescription')}</p>
        <JoinWithCodeForm
          prefillCode={queryCode}
          onClaimed={handleClaimed}
        />
      </div>
    </main>
  )
}

export default JoinWithCodePage
